import React from 'react';

import { hotspotMapMessages } from '../../../../../translates/hotspotMapMessages';
import { useIntlReexport } from '../../../../hooks/useIntlReexport';
import { ToastNotification } from '@ael/shared-components-library';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';

export const HotspotMapCompletedToast: React.FC = () => {
  const { formatMessage } = useIntlReexport();
  return (
    <ToastNotification
      title={formatMessage(hotspotMapMessages.hotspotsCompleted)}
      icon={regular('party-horn')}
      hideCloseButton={true}
      variant="success"
      darkMode={true}
      visible={true}
    />
  );
};
